import { get } from '../fetch-interceptor';
import { RouterAction } from "react-router-redux";
import { AppThunkAction } from ".";
import { Reducer, Action } from "redux";
import { Tracker } from "./PreferencesTracker";
import { Dictionary, UserPreferencesSettingsUpdate } from "../entities/common";
import { defaultCatch } from './utils';
import { saveSettings } from './Sections';

export interface InsightsSettingsState {
    isLoading: boolean;
    settings: any;
}

interface RequestSettingsAction {
    type: 'LOAD_INSIGHTS_SETTINGS';
}

interface ReceiveSettingsAction {
    type: 'LOADED_INSIGHTS_SETTINGS';
    settings: any;
}

interface SaveSettingsAction {
    type: 'SAVE_INSIGHTS_SETTINGS';
    update: UserPreferencesSettingsUpdate;
}

type KnownAction = RequestSettingsAction
    | ReceiveSettingsAction
    | SaveSettingsAction;

export const actionCreators = {
    loadSettings: (): AppThunkAction<KnownAction | RouterAction> => (dispatch, getState) => {
        get<Dictionary<any>[]>(`api/user/preferences/insights`)
            .then(data => dispatch({ type: 'LOADED_INSIGHTS_SETTINGS', settings: data }))
            .catch(defaultCatch(dispatch));

        dispatch({ type: 'LOAD_INSIGHTS_SETTINGS' });
    },
    saveSettings: (update: UserPreferencesSettingsUpdate, sendToServer: boolean = true): AppThunkAction<KnownAction | RouterAction> => (dispatch, getState) => {
        dispatch({ type: 'SAVE_INSIGHTS_SETTINGS', update });
        if (sendToServer) {
            Tracker.setInsightsSettings(dispatch, getState, update);
        }
    }
};

const INIT_STATE: InsightsSettingsState = {
    isLoading: false,
    settings: {}
};

export const reducer: Reducer<InsightsSettingsState> = (state: InsightsSettingsState = INIT_STATE, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'LOAD_INSIGHTS_SETTINGS':
            {
                return {
                    ...state,
                    isLoading: true
                };
            }
        case 'LOADED_INSIGHTS_SETTINGS':
            {
                return {
                    ...state,
                    isLoading: false,
                    isLoaded: true,
                    settings: action.settings
                };
            }
        case 'SAVE_INSIGHTS_SETTINGS': return saveSettings(state, action.update);
    }
    return state;
};